export function initMobileContact() {
    const bar = document.getElementById('mobile-contact');
    const hero = document.getElementById('hero-contact');
    const contact = document.getElementById('contact');
    if (!bar || !hero || !contact) return;

    const mobileLayout = window.matchMedia('(max-width: 760px)');
    let observer: IntersectionObserver | undefined;

    const updateLayout = () => {
        observer?.disconnect();
        observer = undefined;
        bar.hidden = true;
        if (!mobileLayout.matches) return;

        let heroPassed = false;
        let contactVisible = false;
        observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.target === hero) {
                    heroPassed = entry.boundingClientRect.bottom < 0;
                } else if (entry.target === contact) {
                    contactVisible = entry.isIntersecting;
                }
            }
            bar.hidden = !heroPassed || contactVisible;
        });
        observer.observe(hero);
        observer.observe(contact);
    };

    mobileLayout.addEventListener('change', updateLayout);
    updateLayout();
}
